import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Business">
                            <h2>Benefits Of DevOps For Your Business</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                      <p>TekRevol’s DevOps consulting services are a high ROI initiative for our client's businesses. With our DevOps as a Service, we have helped businesses with:</p>
                        <ul>
                            <li>High-quality product delivery&nbsp;</li>
                            <li>More stable operational systems and functional environments&nbsp;</li>
                            <li>faster technical and operational issue resolutions &nbsp;</li>
                            <li>real-time technical testing and correction</li>
                            <li>realistic reflection on business models&nbsp;</li>
                        <li>better resource allocation and utilization&nbsp;</li>
                        <li>newer routes to operational automation and innovation &nbsp;</li>
                    </ul>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;